import * as tslib_1 from "tslib";
import showDiv from '@ivy/fts/showDiv';
import { Component, Vue, Watch } from 'vue-property-decorator';
import * as qs from 'qs';
import CouponListPopup from '../../components/couponListPopup.vue';
import config from '../../config';
import { setTimeout } from 'timers';
import * as _ from 'underscore';
import Cookies from 'js-cookie';
import { isWeixin, sleep, isXcxWeb } from '@ivy/fts/utils';
import { env } from '@ivy/fts/envInfo/envInfo';
import Address from './comps/address.vue';
import GoodsInfo from './comps/goods.vue';
import Pay from './comps/pay.vue';
import InvalidGoods from './comps/InvalidGoods.vue';
import ConfirmPop from './comps/confirmPop.vue';
import * as goodsApi from '@/api/goods';
import { uploadEvent } from '@/api/goods/statistics';
import ExchangeCoin from './comps/exchange-coin.vue';
import BindPhone from '@/components/bindphone.vue';
const PAY_TYPE = {
    coin: '藤币支付',
    wechat: '微信支付',
    gold: '金币支付',
    alipay: '支付宝',
    alipay_hb: '花呗分期',
    alipay_pcredit: '花呗',
};
let OrderConFirm = class OrderConFirm extends Vue {
    constructor() {
        super(...arguments);
        this.goldShow = false;
        this.show = false;
        this.freight = 0; // 运费
        this.products = [];
        this.cartInfo = {}; // 购物车时的商品信息
        this.market = {};
        this.remark = '';
        this.receiver = {};
        this.coupons = [];
        this.uncoupons = [];
        this.type = 'goods';
        this.goodType = ''; // 是否为搭配售商品
        this.need_receiver = false; //是否包含实体商品
        this.btnStatUri = require('../../assets/order/agree.png');
        this.agreeStat = true;
        // isPresell: boolean = false
        this.isFinal = false;
        this.params = '';
        this.isTicket = false;
        this.application = false;
        this.payType = 'wechat'; // 当前支付方式
        this.coinAccount = {}; // 藤币账户
        this.invitation = '';
        this.goldData = {}; // 金币账户
        this.showPayVerify = false;
        this.verifyTid = '';
        this.payDoneRedirect = '';
        this.subject = '';
        this.launch_id = 0;
        this.choosedList = [];
        this.collocationDiscountPrice = 0;
        this.canPayByCoin = false; // 订单是否支持使用藤币
        this.useCoin = false; // 是否使用藤币
        this.useWithdraw = false; // 是否兑换零钱
        this.coinInfo = {}; // 藤币余额
        this.payList = []; // 支付方式列表
        this.payFqInfo = {};
        this.isVip = false; //判断是否是会员
        this.sign = ''; //签名
        this.coupon_id = null;
        this.showBindPhone = false;
        this.scholarship_distribution_id = null;
        this.scholarship_distributor_id = null;
        //订单参数信息
        this.orderParams = {};
        //订单信息
        this.orderData = {};
        this.user_price = ''; // 订单实付价额
    }
    // 是否需要显示零钱或提现中的金额兑换藤币
    get canShowExchangeCoin() {
        return (this.canPayByCoin &&
            +this.payAmount &&
            +this.coinInfo.coin_balance < +this.payAmount &&
            (+this.coinInfo.change_balance > 0 ||
                +this.coinInfo.withdrawal_amount > 0));
    }
    // 零钱或提现中的金额兑换藤币的数量，该值不大于所需要支付的最大值
    get canExchangeCoin() {
        let canUseCoin = +this.coinInfo.change_balance + +this.coinInfo.withdrawal_amount;
        let diffPrice = this.payAmountAndCoin;
        let maxPrice = canUseCoin * 1.2 - +diffPrice;
        return maxPrice > 0
            ? (+diffPrice).toFixed(2)
            : Math.abs(canUseCoin * 1.2).toFixed(2);
    }
    get coinImg() {
        return this.useCoin
            ? require('../../assets/check.png')
            : require('../../assets/un-check.png');
    }
    get coinExchangeImg() {
        return this.useWithdraw
            ? require('../../assets/check.png')
            : require('../../assets/un-check.png');
    }
    get isDistribution() {
        return (this.products[0].activity &&
            this.products[0].activity.distribution &&
            this.products[0].activity.distribution.id);
    }
    get productsPrice() {
        if (this.isDistribution) {
            return this.products[0].sale_price;
        }
        else {
            return this.products.reduce((sum, cur) => {
                return cur.goods_type === 'goods_gift'
                    ? sum
                    : (sum +=
                        cur.channel_activity && !this.activityNames.length
                            ? parseFloat(cur.activityPrice)
                            : !this.goodType // 是否是搭配购，搭配购取final_price
                                ? parseFloat(cur.sale_price)
                                : parseFloat(cur.sale_price) * parseFloat(cur.num));
            }, 0);
        }
    }
    get isPreselling() {
        let start_time = this.market.presell.id &&
            this.market.presell.presell_start_time.replace(/-/g, '/');
        let end_time = this.market.presell.id &&
            this.market.presell.presell_end_time.replace(/-/g, '/');
        return (new Date(start_time).getTime() <= new Date().getTime() &&
            new Date().getTime() < new Date(end_time).getTime());
    }
    get isFinalStart() {
        let start_time = this.market.presell.id &&
            this.market.presell.final_payment_start_time.replace(/-/g, '/');
        return new Date(start_time).getTime() <= new Date().getTime();
    }
    get isFinalEnd() {
        let end_time = this.market.presell.id &&
            this.market.presell.final_payment_end_time.replace(/-/g, '/');
        return new Date(end_time).getTime() <= new Date().getTime();
    }
    get actualPaid() {
        let actualPaid = 0.0;
        if (+this.market.presell.expanding_deposit > 0) {
            actualPaid =
                +this.market.presell.discount_price -
                    +this.market.presell.expanding_deposit +
                    +this.freight -
                    +(this.isPreselling
                        ? '0.00'
                        : this.market.coupon.discount_price
                            ? this.market.coupon.discount_price.toFixed(2)
                            : '0.00');
        }
        else {
            actualPaid =
                +this.market.presell.discount_price -
                    +this.market.presell.deposit +
                    +this.freight -
                    +(this.isPreselling
                        ? '0.00'
                        : this.market.coupon.discount_price
                            ? this.market.coupon.discount_price.toFixed(2)
                            : '0.00');
        }
        return +actualPaid > 0 ? +actualPaid.toFixed(2) : 0.0;
    }
    get presellText() {
        return this.isFinalStart
            ? `（${this.market.presell.final_payment_end_time}结束)`
            : `（${this.market.presell.final_payment_start_time}开始)`;
    }
    get expandingText() {
        let text = '定金抵作同价货款,不退还';
        if (this.market.presell.id &&
            +this.market.presell.expanding_deposit < 0.01 &&
            this.isFinal) {
            text = '已支付 定金抵作同价货款,不退还';
        }
        else if (this.market.presell.id &&
            +this.market.presell.expanding_deposit < 0.01 &&
            !this.isFinal) {
            text = '定金抵作同价货款,不退还';
        }
        else if (this.market.presell.id &&
            +this.market.presell.expanding_deposit >= 0.01 &&
            this.isFinal) {
            text = `已支付 ${this.market.presell.deposit}元抵扣${this.market.presell.expanding_deposit}元，不退还`;
        }
        else if (this.market.presell.id &&
            +this.market.presell.expanding_deposit >= 0.01 &&
            !this.isFinal) {
            text = `${this.market.presell.deposit}元抵扣${this.market.presell.expanding_deposit}元，不退还`;
        }
        return text;
    }
    get payAmount() {
        //预售读取预售金额
        if (this.market.presell.id && !this.isFinalStart && this.isPreselling) {
            return +this.market.presell.deposit;
        }
        else {
            return this.orderData.total_final_price;
        }
        // let payAmount = +this.productsPrice || 0
        // let flag = true
        // if (this.market.limit_buy && this.market.limit_buy.id) {
        //   payAmount = +this.market.limit_buy.sale_price + +this.freight
        //   flag = false
        // }
        // if (this.market.coupon && this.market.coupon.id) {
        //   // payAmount -= +this.market.coupon.discount_price + +this.freight // 运算优先级问题
        //   payAmount =
        //     Math.max(payAmount - +this.market.coupon.discount_price, 0) +
        //     +this.freight
        //   flag = false
        // }
        // if (this.market.group && this.market.group.id) {
        //   // payAmount -= +this.market.group.discount + +this.freight // 运算优先级问题
        //   payAmount = payAmount - +this.market.group.discount + +this.freight
        //   flag = false
        // }
        // if (
        //   this.market.presell.id &&
        //   this.isFinalStart &&
        //   !this.isFinalEnd &&
        //   this.isFinal
        // ) {
        //   payAmount = +this.actualPaid
        //   flag = false
        // }
        // // 搭配购
        // if (
        //   this.goodType &&
        //   this.collocationDiscountPrice &&
        //   +this.collocationDiscountPrice > 0
        // ) {
        //   payAmount -= +this.collocationDiscountPrice
        //   flag = false
        // }
        // if (flag) {
        //   // 有一种什么活动，上面都匹配不到的情况，没有计算运费，所以暂时用这种方式去匹配条件
        //   payAmount += this.freight
        // }
        // // if (this.useCoin) {
        // //   let payMoney = payAmount - this.coinInfo.coin_balance
        // //   payAmount = payMoney < 0 ? 0 : payMoney
        // // }
        // console.log('33333', this.productsPrice, payAmount)
        // return Math.max(payAmount, 0).toFixed(2)
    }
    get payAmountAndCoin() {
        if (this.canPayByCoin && this.useCoin) {
            let payMoney = +this.payAmount - this.coinInfo.coin_balance;
            return Math.max(payMoney, 0).toFixed(2);
        }
        return this.payAmount;
    }
    get payAmountCart() {
        let payAmountCart = this.isVip
            ? +this.cartInfo.total_goods_price - +this.cartInfo.freight
            : +this.cartInfo.total_price - +this.cartInfo.freight;
        return (Math.max(payAmountCart, 0) + +this.cartInfo.freight).toFixed(2);
    }
    get activityNames() {
        let r = [
            !_.isEmpty(this.market.presell) && 'presell',
            !_.isEmpty(this.market.group) && 'group',
            !_.isEmpty(this.market.limit_buy) && 'limit_buy',
            !_.isEmpty(this.market.distribution) && 'distribution',
        ].filter(e => e);
        return r;
    }
    get giftFilter() {
        return this.products[0].giftsActivity.gift.filter(i => !i.soldOut);
    }
    get productsFilter() {
        return this.products.filter(i => i.goods_type === 'goods_gift');
    }
    get showCoupons() {
        let market = this.market;
        if (!this.isTicket) {
            return true;
        }
        let isPresellMarket = market.presell && market.presell.id && this.isFinalStart;
        let notPresellMarket = !market.presell || !market.presell.id;
        let hasCoupons = this.coupons && this.coupons.length > 0;
        if ((notPresellMarket || isPresellMarket) && hasCoupons) {
            return true;
        }
        return false;
    }
    get selectCoupon() {
        let market = this.market;
        let isPresellMarket = market.presell && market.presell.id && this.isFinalStart;
        let notPresellMarket = !market.presell || !market.presell.id;
        return market.coupon && (isPresellMarket || notPresellMarket);
    }
    get isCart() {
        return this.$route.query.isCart === 'true';
    }
    get isCartWithPro() {
        return ((this.cartInfo.product_info &&
            this.cartInfo.product_info.sku_info &&
            this.cartInfo.product_info.sku_info.length) ||
            0);
    }
    get invalidPros() {
        return ((this.cartInfo.product_info &&
            this.cartInfo.product_info.invalided_sku_info) ||
            []);
    }
    get uploadEvent() {
        return uploadEvent;
    }
    get isApp() {
        return env.type === 'ivydad' || env.type === 'web';
    }
    async created() {
        //判断是否是会员
        await uploadEvent.init();
        await env.init();
        const isLogin = await env.getIsLogin();
        if (!isLogin) {
            return await env.login();
        }
        let loginInfo = await env.getInfo();
        if (this.isApp) {
            if (loginInfo.userInfo && loginInfo.userInfo.isVip == '1')
                this.isVip = true;
        }
        else {
            if (loginInfo.logined && loginInfo.logined.vip)
                this.isVip = true;
        }
        let { type, skuId, channel_id, receiver_id, from, ignoreDiscount, application, invitation, goldValue, channel_activity, gift_activity, isGroup, orderId, cid, goodType, scholarship_distribution_id, scholarship_distributor_id, sign, user_price, } = this.$route.query;
        this.invitation = invitation;
        this.skuId = skuId;
        this.goodType = goodType;
        this.type = type;
        this.sign = sign;
        this.goldShow = !(invitation === 'gold');
        if (application === 'true') {
            this.application = true;
        }
        this.isFinal = from === 'final';
        this.isTicket = from === 'ticket';
        this.channel_activity = channel_activity;
        this.gift_activity = gift_activity;
        this.scholarship_distributor_id = scholarship_distributor_id;
        this.scholarship_distribution_id = scholarship_distribution_id;
        this.user_price = user_price;
        let data = {};
        if (this.isCart) {
            // 是购物车订单
            const confirmInfo = window.sessionStorage.getItem(`confirm_id_${this.$route.query.confirmId}`);
            if (!confirmInfo) {
                this.$Toast('参数已失效, 请重新进入购物车结算');
                await sleep(1200);
                return this.$router.push({
                    path: '/cart',
                    query: {
                        navBarHide: '1',
                    },
                });
            }
            let skus = JSON.parse(confirmInfo);
            await this.getAddress();
            const { data } = await goodsApi.getConfirmInfo({
                skus: skus,
                receiver_id: this.receiver.id,
                is_use_new_coupon: 1,
                scholarship_distribution_id,
                scholarship_distributor_id,
            });
            this.cartInfo = data || {};
            await this.initPayType(skus.map(item => {
                return {
                    id: item.sku_id,
                    num: item.num,
                    type: item.type,
                };
            }));
        }
        else {
            this.orderParams = {
                confirmSkus: [
                    {
                        id: skuId,
                        type,
                        channel_activity,
                        gift_activity,
                        isGroup,
                        user_price,
                    },
                ],
                prepay_type: invitation === 'gold' ? 'water' : '',
                ignoreDiscount: +!!ignoreDiscount,
                channel_id,
                orderId: (from === 'final' && orderId) || undefined,
                is_use_new_coupon: 1,
                scholarship_distribution_id,
                scholarship_distributor_id,
            };
            if (goodType) {
                if (!Array.isArray(this.skuId)) {
                    // 不是数组变为数组
                    this.skuId = this.skuId.split(',');
                }
                let sku = this.skuId.map((item, index) => {
                    return {
                        id: item,
                        type: 'goods',
                        collocation_id: cid,
                    };
                });
                await this.initPayType(sku);
            }
            else {
                let _skus = [
                    {
                        id: skuId,
                        type,
                        isTrueGroup: isGroup,
                    },
                ];
                await this.initPayType(_skus);
            }
            await this.getOrderInfo();
        }
        if (this.isCart) {
            this.canPayByCoin =
                this.cartInfo.is_support_coin && this.payType !== 'coin'; // 支持藤币组合支付
            this.products =
                (this.cartInfo.product_info && this.cartInfo.product_info.sku_info) ||
                    [];
            this.collocationDiscountPrice = this.cartInfo.collocation_discount_price;
            this.need_receiver = this.cartInfo.need_receiver;
            const cartComponsMap = (this.cartInfo.new_coupon_list || []).filter(item => +item.is_disabled === 0);
            const cartUnComponsMap = (this.cartInfo.new_coupon_list || []).filter(item => +item.is_disabled === 1);
            this.coupons = cartComponsMap || [];
            this.uncoupons = cartUnComponsMap || [];
            this.market.coupon = (this.coupons && this.coupons[0]) || {};
            this.market.presell = {};
            this.market.limit_buy = {};
        }
        this.invitation === 'gold' ? await this.getGold() : await this.getCoin();
        if (this.$route.query.isGroup) {
            // 是否参与拼团
            // 当前商品是否存在拼团活动
            this.market.group =
                (this.products[0].activity && this.products[0].activity.group) || {};
        }
        this.channel_activity =
            (this.products[0] && this.products[0].channel_activity) || 0;
        this.gift_activity =
            (this.products[0] && this.products[0].gift_activity) || 0;
        this.giftConfirm =
            (this.products[0] &&
                this.products[0].gift_activity &&
                this.products[0].giftsActivity &&
                this.products[0].giftsActivity.gift
                    .filter(item => !item.soldOut)
                    .map(item => item.barcode)) ||
                [];
        this.canPayByCoin && (await this.getCoinInfo());
        this.show = true;
        this.$title('确认订单');
        // 电商埋点-确认订单页曝光
        uploadEvent.sendRecord('Exposure_ConfirmOrder', '', this.products.reduce((t, c, i) => {
            t.SkuID = t.SkuID += i === 0 ? `${c.id}` : `_${c.id}`;
            t.GoodsName = t.GoodsName += i === 0 ? `${c.title}` : `_${c.title}`;
            return t;
        }, {
            FromPage: 1,
            GoodsName: '',
            SkuID: '',
        }), [
            ['p1', 'FromPage'],
            ['p2', 'SkuID'],
        ]);
    }
    //获取订单数据
    async getOrderInfo() {
        let data;
        //搭配售
        if (this.goodType) {
            // 是否是搭配购项目
            if (!Array.isArray(this.skuId)) {
                // 不是数组变为数组
                this.skuId = this.skuId.split(',');
            }
            let sku = this.skuId.map((item, index) => {
                return {
                    id: item,
                    type: 'goods',
                    collocation_id: this.$route.query.cid,
                };
            });
            await this.initPayType(sku);
            console.log('搭配售 sku：', sku, this.user_price);
            data = await this.$axios.post('/api/goods/order/order/getMutiConfirmInfo', {
                confirmSkus: sku,
                is_use_new_coupon: 1,
                scholarship_distribution_id: this.scholarship_distribution_id,
                scholarship_distributor_id: this.scholarship_distributor_id,
                receiver_id: this.receiver.id,
                coupon_id: this.coupon_id,
                is_optimal_price: 1,
                user_price: this.user_price,
            });
            const couponsMap = (data.new_coupons || []).filter(item => +item.is_disabled === 0);
            const uncouponsMap = (data.new_coupons || []).filter(item => +item.is_disabled === 1);
            this.coupons = couponsMap || [];
            this.uncoupons = uncouponsMap || [];
            //自动领取优惠券
            if (this.coupons && this.coupons.length && data.selected_coupon_id) {
                let select = this.coupons.filter(item => +item.id === +data.selected_coupon_id);
                this.market.coupon = select[0];
            }
            else {
                this.market.coupon = {};
            }
            if (data.tips) {
                this.$Toast(data.tips);
            }
        }
        else {
            data = await this.$axios.get('/api/goods/order/order/getConfirmInfo', {
                params: {
                    ...this.orderParams,
                    receiver_id: this.receiver.id,
                    coupon_id: this.coupon_id,
                    is_optimal_price: 1,
                },
            });
        }
        this.freight = data.data.freight || 0;
        this.orderData = data.data;
        data = data.data;
        this.canPayByCoin = data.is_support_coin && this.payType !== 'coin';
        this.products = data.skus;
        this.collocationDiscountPrice = data.collocation_discount_price;
        this.need_receiver = !!data.need_receiver;
        const couponsMap = (data.new_coupons || []).filter(item => +item.is_disabled === 0);
        const uncouponsMap = (data.new_coupons || []).filter(item => +item.is_disabled === 1);
        this.coupons = couponsMap || [];
        this.uncoupons = uncouponsMap || [];
        //自动领取优惠券
        if (this.coupons && this.coupons.length && data.selected_coupon_id) {
            let select = this.coupons.filter(item => +item.id === +data.selected_coupon_id);
            this.market.coupon = select[0];
        }
        else {
            this.market.coupon = {};
        }
        if (data.tips) {
            this.$Toast(data.tips);
        }
        this.market.presell =
            (this.products[0].activity && this.products[0].activity.presell) || {};
        this.market.limit_buy =
            (this.products[0] &&
                this.products[0].activity &&
                this.products[0].activity.limit_buy) ||
                {};
    }
    async getCoinInfo() {
        try {
            let { data } = await this.$axios.get('/api/mobile/account/balance');
            this.coinInfo = data;
            // 1. 有藤币
            if (+data.coin_balance) {
                // 1.1 藤币大于支付金额
                if (+data.coin_balance >= +this.payAmount) {
                    this.useCoin = false;
                    this.useWithdraw = false;
                }
                else {
                    this.useCoin = true;
                    // 1.2 是否有提现中的零钱
                    if (+data.change_balance > 0 || +data.withdrawal_amount > 0) {
                        this.useWithdraw = true;
                    }
                    else {
                        this.useWithdraw = false;
                    }
                }
            }
            else {
                // 2. 没有藤币
                this.useCoin = false;
                // 2.1 判断是否有提现中的零钱
                if (+data.change_balance > 0 || +data.withdrawal_amount > 0) {
                    this.useWithdraw = true;
                }
                else {
                    this.useWithdraw = false;
                }
            }
        }
        catch (e) {
            this.coinInfo = {};
        }
    }
    async getAddress() {
        let { data } = await this.$axios.post(`/api/mobile/course/yaya/getUserReceiver`);
        this.receiver = data.find(item => item.is_default) || {};
    }
    async getCoin() {
        const { data } = await this.$axios.get('/api/mobile/account/coin/account');
        this.coinAccount = data;
    }
    async getGold() {
        let { spuId } = this.$route.query;
        // 屏蔽这个错误，但是实际上这个请求就不应该直接发起
        let { data, } = await this.$axios.get(`/api/activity/h5Activity/invitation/getGoodsPrice?spuId=${spuId}`, { disableAlert: true });
        this.goldData = data;
    }
    async initPayType(skus) {
        const { pt = 'wechat' } = this.$route.query;
        this.payType = pt;
        // if (!PAY_TYPE[pt as string]) {
        //   // 错误参数
        //   return (window.location.href = 'https://m.ivydad.com/center/')
        // }
        // 请求
        let { data } = await this.$axios.post('/api/goods/order/order/getPayTypeList', {
            skus: skus,
        });
        console.log('------', data);
        this.payList = data;
    }
    agreeRule() {
        this.agreeStat = this.agreeStat ? false : true;
        this.btnStatUri = this.agreeStat
            ? require('../../assets/order/agree.png')
            : require('../../assets/order/disagree.png');
    }
    showRule() {
        this.$router.push({
            path: `/presellRule`,
            query: {
                ruleUrl: this.market.presell.rule_pic,
            },
        });
    }
    async showCouponList() {
        let uploadParmas = this.products.reduce((t, c, i) => {
            t.SkuID = t.SkuID += i === 0 ? `${c.id}` : `_${c.id}`;
            t.GoodsName = t.GoodsName += i === 0 ? `${c.title}` : `_${c.title}`;
            return t;
        }, {
            GoodsName: '',
            SkuID: '',
            CouponsID: this.market.coupon.id || '',
        });
        // 电商埋点-确认订单页点击可用优惠券
        uploadEvent.sendRecord('Click_ConfirmOrder_Coupons', '', uploadParmas, [
            ['p1', 'SkuID'],
            ['p3', 'CouponsID'],
        ]);
        const thresholdPrice = this.getThresholdPrice();
        let userCouponId = this.market.coupon.id;
        let coupon_user_id = this.market.coupon.coupon_user_id;
        let _coupon = await showDiv(CouponListPopup, {
            visible: true,
            mode: 'select',
            from: 'orderConfirm',
            uploadEvent: uploadEvent,
            userCouponId,
            couponUserId: coupon_user_id,
            originCoupons: this.coupons,
            originUnCoupons: this.uncoupons,
            product: { thresholdPrice, type: this.type, course_id: this.skuId },
            uploadParmas,
        });
        this.market = { ...this.market, coupon: _coupon };
        if (this.isCart &&
            this.market.coupon &&
            this.market.coupon.id !== userCouponId) {
            const confirmInfo = window.sessionStorage.getItem(`confirm_id_${this.$route.query.confirmId}`);
            if (!confirmInfo) {
                this.$Toast('参数已失效, 请重新进入购物车结算');
                await sleep(1200);
                return this.$router.push({
                    path: '/cart',
                    query: {
                        navBarHide: '1',
                    },
                });
            }
            const { data } = await goodsApi.getConfirmInfo({
                skus: JSON.parse(confirmInfo),
                receiver_id: this.receiver.id,
                coupon_code: this.market.coupon.code,
            });
            this.cartInfo.total_price = data.total_price;
        }
        //如果更换优惠券或者不使用优惠券了，重新算价
        if (this.market.coupon &&
            this.market.coupon.id &&
            this.market.coupon.id !== userCouponId) {
            this.coupon_id = this.market.coupon.id;
            this.getOrderInfo();
        }
        else if (!this.market.coupon || !this.market.coupon.id) {
            this.coupon_id = 0;
            this.getOrderInfo();
        }
    }
    getThresholdPrice() {
        let payAmount = +this.productsPrice || 0;
        if (this.market.limit_buy && this.market.limit_buy.id) {
            payAmount = +this.market.limit_buy.sale_price;
        }
        if (this.market.group && this.market.group.id) {
            payAmount -= +this.market.group.discount;
        }
        return Math.max(payAmount, 0).toFixed(2);
    }
    updatePayType(type) {
        this.payType = type;
    }
    updatePayFqInfo(fqInfo) {
        this.payFqInfo = fqInfo;
    }
    async onPay() {
        // this.$router.push({
        //   path: 'orderPay',
        //   query: {},
        // })
        // return
        // 电商埋点-确认订单页点击提交
        let { scholarship_distribution_id, scholarship_distributor_id, } = this.$route.query;
        await uploadEvent.sendRecord('Click_ConfirmOrder_Submit', '', this.products.reduce((t, c, i) => {
            t.SkuID = t.SkuID += i === 0 ? `${c.id}` : `_${c.id}`;
            t.GoodsName = t.GoodsName += i === 0 ? `${c.title}` : `_${c.title}`;
            return t;
        }, {
            GoodsName: '',
            SkuID: '',
        }), [['p1', 'SkuID']]);
        if (this.market.presell.id &&
            (this.isPreselling || this.isFinal) &&
            !this.agreeStat) {
            return this.$Toast('请同意预售规则');
        }
        if (this.need_receiver && !this.receiver.id) {
            return this.$Toast('请选择收货地址');
        }
        // 1. 判断是否选中了零钱兑换藤币,需支付金额必须大于0
        if (this.useWithdraw && this.canShowExchangeCoin) {
            let price = +this.payAmount;
            // 是否选中了使用现有藤币
            if (this.useCoin) {
                price = +this.payAmount - this.coinInfo.coin_balance;
            }
            // 弹出藤币兑换框
            let re = await showDiv(ExchangeCoin, {
                exchangePrice: this.payAmountAndCoin,
                products: this.products,
            });
            re && this.getCoinInfo();
            return;
        }
        if (this.remark === '请输入备注信息') {
            this.remark = '';
        }
        const globalParam = {
            distributorMemId: sessionStorage.getItem('_sessionStorageDistributorMemId') ||
                sessionStorage.getItem('_cookieDistributorMemId'),
            appName: sessionStorage.getItem('_sessionStorageAppName') ||
                Cookies.get('_cookieAppName'),
            channel_id: this.$route.query.channel_id ||
                sessionStorage.getItem('_sessionStorageChannelId') ||
                sessionStorage.getItem('_cookieChannelId'),
            invite_activity_id: this.$route.query._sessionStorageInviteActivityId ||
                sessionStorage.getItem('_sessionStorageInviteActivityId'),
            trade_type: isWeixin() ? null : 'MWEB',
        };
        let order = {
            pay_type: this.payType,
            hbfq_num: this.payFqInfo.stage || 0,
            type: 'normal',
            receiver_id: this.need_receiver && this.receiver.id,
            remark: this.remark,
            ignore_gift: 1,
            skus: [
                {
                    id: this.skuId,
                    type: this.type,
                    num: 1,
                },
            ],
            coupon_user_ids: this.market && this.market.coupon && this.market.coupon.coupon_user_id
                ? [this.market.coupon.coupon_user_id]
                : null,
        };
        if (scholarship_distribution_id && scholarship_distributor_id) {
            order = {
                ...order,
                scholarship_distribution_id,
                scholarship_distributor_id,
            };
        }
        let isAllCoin = false;
        // 选择了使用藤币支付
        if (this.useCoin && this.canPayByCoin) {
            // 藤币是否足够支付商品价格
            isAllCoin = +this.payAmountAndCoin === 0;
            if (isAllCoin) {
                order.pay_type = 'coin';
                order.total_fee = this.payAmount;
            }
            else {
                order.pay_type = 'combined_payment';
                order.total_fee = +this.coinInfo.coin_balance + +this.payAmountAndCoin;
                order.combine_pay = [
                    {
                        pay_type: this.payType,
                        amount: this.payAmountAndCoin,
                    },
                    {
                        pay_type: 'coin',
                        amount: +this.coinInfo.coin_balance,
                    },
                ];
            }
        }
        if (this.market.presell.id && (this.isFinal || this.isPreselling)) {
            order = {
                ...order,
                type: 'presell',
                orderId: +this.$route.query.orderId,
                skus: [
                    {
                        id: this.skuId,
                        type: this.type,
                        num: 1,
                        presell: {
                            activity_id: this.market.presell.activity_id,
                            presell_pay_type: this.isFinalStart ? 'tail_money' : 'deposit',
                        },
                    },
                ],
            };
        }
        if (this.$route.query.isGroup) {
            let { group_order_id } = this.$route.query;
            let group = {
                activity_id: this.market.group.id,
                action: 'create',
            };
            if (group_order_id) {
                group.group_order_id = group_order_id;
                group.action = 'join';
            }
            order = {
                ...order,
                type: 'group',
                skus: [
                    {
                        id: this.skuId,
                        type: this.type,
                        num: 1,
                        group,
                    },
                ],
            };
        }
        if (this.market.limit_buy && this.market.limit_buy.id) {
            order = {
                ...order,
                type: 'normal',
                skus: [
                    {
                        id: this.skuId,
                        type: this.type,
                        num: 1,
                        limit_buy: this.market.limit_buy.id,
                    },
                ],
            };
        }
        if (this.isTicket) {
            order = {
                ...order,
                pay_type: 'ticket',
                skus: [
                    {
                        id: this.skuId,
                        type: this.type,
                        num: 1,
                        ticket: this.$route.query.activity_id,
                    },
                ],
            };
        }
        if (this.invitation) {
            order = {
                ...order,
                pay_type: 'water',
                skus: [
                    {
                        id: this.skuId,
                        type: this.type,
                        num: 1,
                    },
                ],
                coupon_user_ids: null,
            };
        }
        if (this.channel_activity) {
            order = {
                ...order,
                skus: [
                    {
                        id: this.skuId,
                        type: this.type,
                        num: 1,
                        channel_activity: this.channel_activity,
                    },
                ],
            };
        }
        if (this.gift_activity) {
            order.skus[0].gift_activity = this.gift_activity;
            order.skus[0].giftConfirm = this.giftConfirm;
        }
        if (this.goodType) {
            // 是否为搭配售
            let sku = this.skuId.map((item, index) => {
                let productInfo = this.products.find(product => +product.id === +item);
                return {
                    id: item,
                    type: 'goods',
                    num: productInfo.num || 1,
                    collocation_id: this.$route.query.cid,
                };
            });
            order = {
                ...order,
                skus: sku,
                type: 'collocation',
            };
        }
        let pay = {};
        if (isXcxWeb()) {
            let { xcxopenid, xcxappid } = JSON.parse(window.localStorage.getItem('xcxInfo') || '{}');
            if (!xcxopenid) {
                return wx.miniProgram.navigateTo({
                    url: `/pages/webauth/index?redirectUrl=${encodeURIComponent(window.location.href)}`,
                });
            }
            order = { ...order, sys_type: 'h5', openid: xcxopenid, appid: xcxappid };
        }
        if (this.market.presell.id &&
            this.isFinalStart &&
            !this.isFinalEnd &&
            this.isFinal) {
            pay = await this.$axios.post(`/api/goods/order/order/payFinalPresellOrder`, {
                ...order,
                ...globalParam,
            });
        }
        else {
            if (this.isTicket) {
                pay = await this.$axios.post(`/api/goods/order/order/submitTicketOrder`, {
                    ...order,
                    ...globalParam,
                });
            }
            else if (this.payType === 'coin') {
                pay = await this.$axios.post(`/api/goods/order/order/submitCoinOrder`, {
                    ...order,
                    ...globalParam,
                    coin_balance: this.coinAccount.balance,
                    sign: this.sign,
                });
            }
            else if (this.invitation) {
                pay = await this.$axios.post(`/api/goods/order/order/submitWaterOrder`, {
                    ...order,
                    ...globalParam,
                    gold_balance: this.goldData.golds_count,
                });
                console.log(this.productsPrice, '价格');
            }
            else {
                pay = await this.$axios.post(`/api/goods/order/order/submit`, {
                    ...order,
                    ...globalParam,
                    sign: this.sign,
                }, {
                    disableAlert: true,
                });
            }
        }
        let openAccess = false; // 是否手动开启权限
        if (pay.data.code === 20001) {
            console.log('000000', pay.data);
            this.showBindPhone = true;
            return;
        }
        else if (pay.data.code) {
            if (!this.need_receiver && this.productsPrice === 0) {
                // 判断是否符合手动开启课程权限的条件, 0元不带实物
                const { data: { enable }, } = await this.$axios.get(`/api/goods/order/order/checkFreeBuy?sku_id=${this.skuId}`);
                if (enable) {
                    const { data: { subject, launchId }, } = await this.$axios.post('/api/m-course/course/grant', {
                        courseId: this.$route.query.course_id,
                    }); // 调用接口开启课程权限
                    if (launchId && subject) {
                        // 权限开启成功
                        openAccess = true;
                        this.subject = subject;
                        this.launch_id = launchId;
                    }
                }
                else {
                    return this.$Toast(pay.data.message);
                }
            }
            else {
                return this.$Toast(pay.data.message);
            }
        }
        // if (pay.data.code === 3 && pay.data.type === 'DUPLICATE-AUTH') {
        // if (pay.data.code === 2) {
        // const {
        //   data: { exists },
        // } = await this.$axios.get(
        //   '/api/goods/order/experienceCourse/existsPhysicalGoodsOrder'
        //   // ) //
        //   if (!this.need_receiver && this.productsPrice === 0) {
        //     // 判断是否符合手动开启课程权限的条件, 0元不带实物
        //     const {
        //       data: { subject, launchId },
        //     } = await this.$axios.post('/api/m-course/course/grant', {
        //       courseId: this.$route.query.course_id,
        //     }) // 调用接口开启课程权限
        //     if (launchId && subject) {
        //       // 权限开启成功
        //       openAccess = true
        //       this.subject = subject
        //       this.launch_id = launchId
        //     }
        //   } else {
        //     return this.$Toast(pay.data.message)
        //   }
        // } else if (pay.data.message) {
        //   return this.$Toast(pay.data.message)
        // }
        // 电商埋点-提交订单成功
        await uploadEvent.sendRecord('ConfirmOrder_Submit_Success', '', { Tid: pay.data.tid }, [['p1', 'Tid']]);
        let { type, spuId, channel_id, invitationId } = this.$route.query;
        let _redirect = `${window.location.origin}/goods/payDone?tid=${pay.data.tid}&spuId=${spuId}&channel_id=${channel_id || ''}&type=${type}&application=${this.$route.query.application}&startTime=${this.$route.query.start_time}${openAccess
            ? `&openAccess=${openAccess}&subject=${this.subject}&launch_id=${this.launch_id}&course_id=${this.$route.query.course_id}`
            : ''}`;
        this.$route.query.isGroup &&
            pay.data.group_order_id &&
            (_redirect = `${window.location.origin}/goods/groupView?spuId=${spuId}&channel_id=${channel_id ||
                ''}&type=${type}&orgId=${pay.data.group_order_id}`);
        // 藤币提交订单的时候就支付了
        if (+pay.data.total_fee < 0.01 ||
            this.payType === 'coin' ||
            isAllCoin ||
            openAccess) {
            window.location.replace(_redirect);
            return;
        }
        if (this.isTicket) {
            this.$router.push(`/payDone?tid=${pay.data.tid}&spuId=${spuId}&type=${type}&ticket=0&activity_id=${this.$route.query.activity_id}`);
        }
        else if (this.invitation) {
            // this.$router.push(`/invitation/goldDetails?activityId=${invitationId}`)
            window.location.href = window.location.origin + `/invitation/myExchange`;
        }
        else {
            if (isXcxWeb()) {
                let package1;
                let index = pay.data.package.indexOf('=');
                if (index !== -1) {
                    package1 = pay.data.package.slice(index + 1);
                }
                wx.miniProgram.navigateTo({
                    url: `/pages/webpay/index?timestamp=${pay.data.timeStamp}&nonceStr=${pay.data.nonceStr}&package=${pay.data.package}&signType=${pay.data.signType}&paySign=${pay.data.paySign}&package1=${package1}`,
                });
                await sleep(1000);
                this.showPayVerify = true;
                this.verifyTid = pay.data.tid;
                this.payDoneRedirect = _redirect;
                return;
            }
            // let re = await showDiv(Goodspay, {})
            // 如果选择的是支付宝支付，则需要跳转至中间页
            if (this.payType === 'alipay' || this.payType === 'alipay_hb') {
                let payInfo = _.pick(pay.data, [
                    'order_id',
                    'pay_channel',
                    'pay_type',
                    'is_presell_final',
                    'discount_amount',
                    'sys_type',
                    'amount',
                ]);
                let payType = payInfo.pay_type;
                if (!payType) {
                    payType = {
                        wechat: 1,
                        alipay: 2,
                        coin: 4,
                        alipay_hb: 17,
                        combined_payment: 1000,
                    }[this.payType];
                }
                let payChannel = payInfo.pay_channel;
                if (!payChannel) {
                    payChannel = 3;
                }
                this.$router.push({
                    path: 'orderPay',
                    query: {
                        ...payInfo,
                        _redirect,
                        pay_type: payType,
                        pay_channel: payChannel,
                        is_presell_final: +this.isFinal + '',
                        combine_pay: JSON.stringify(pay.data.combine_pay || '') || '',
                        hbfq_num: this.payFqInfo.stage || 0,
                    },
                });
            }
            else {
                let host = config.env === 'production' ? window.location.host : 'm.ivydad.com.cn';
                if (host.indexOf('simulate') >= 0)
                    host = 'm.ivydad.com';
                _redirect += '&toList=true';
                window.location.replace(`//${host}/pay/?${qs.stringify({
                    pay: { ...pay.data },
                    redirect: _redirect,
                })}`);
            }
        }
    }
    async verifyPayDone() {
        const { data: payResult } = await this.$axios.get(`/api/goods/order/pay/getPayResult?tid=${this.verifyTid}`);
        if (payResult.state === 'paid') {
            // 支付成功
            this.$Toast('支付成功');
            // window.location.replace(`${_redirect}${_redirect.includes('?') ? '&' : '?'})}`)
            window.location.replace(this.payDoneRedirect);
            return;
        }
        else {
            await this.$Toast('支付失败请稍后重试');
            await sleep(50);
            // const jumpLink = decodeURIComponent(`${cancelUrl}`)
            // window.location.replace(jumpLink)
        }
        this.showPayVerify = false;
    }
    // payTicket() {
    //   if (!this.receiver.id && this.need_receiver) {
    //     return this.$Toast('请选择收货地址')
    //   }
    //   if (this.remark === '请输入备注信息') {
    //     this.remark = ''
    //   }
    //   let order: any = {
    //     pay_type: 'ticket',
    //     type: 'normal',
    //     receiver_id: this.need_receiver && this.receiver.id,
    //     remark: this.remark,
    //     ignore_gift: 1,
    //     skus: [
    //       {
    //         id: this.skuId,
    //         type: this.type,
    //         num: 1,
    //         ticket: this.$route.query.activity_id,
    //       },
    //     ],
    //     coupon_user_ids:
    //       this.market && this.market.coupon && this.market.coupon.coupon_user_id
    //         ? [this.market.coupon.coupon_user_id]
    //         : null,
    //     distributorMemId:
    //       sessionStorage.getItem('_sessionStorageDistributorMemId') ||
    //       sessionStorage.getItem('_cookieDistributorMemId'),
    //     appName:
    //       sessionStorage.getItem('_sessionStorageAppName') ||
    //       Cookies.get('_cookieAppName'),
    //   }
    // }
    inputLoseFocus() {
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 100);
    }
    async getFreight() {
        const { skuId, type } = this.$route.query;
        if (this.isCart) {
            // 是购物车订单
            const confirmInfo = window.sessionStorage.getItem(`confirm_id_${this.$route.query.confirmId}`);
            if (!confirmInfo) {
                this.$Toast('参数已失效, 请重新进入购物车结算');
                await sleep(1200);
                return this.$router.push({
                    path: '/cart',
                    query: {
                        navBarHide: '1',
                    },
                });
            }
            const { data } = await goodsApi.getConfirmInfo({
                skus: JSON.parse(confirmInfo),
                receiver_id: this.receiver.id,
            });
            this.cartInfo.total_price = data.total_price;
            this.cartInfo.freight = data.freight;
        }
        else if (this.receiver && this.receiver.id && !this.goodType) {
            //搭配售的运费默认为0 所以搭配售商品修改地址不需要重新算价
            this.getOrderInfo();
        }
        else {
            this.freight = 0;
        }
    }
    async onPayNew() {
        // 电商埋点-确认订单页点击提交
        await uploadEvent.sendRecord('Click_ConfirmOrder_Submit', '', this.products.reduce((t, c, i) => {
            t.SkuID = t.SkuID += i === 0 ? `${c.id}` : `_${c.id}`;
            t.GoodsName = t.GoodsName += i === 0 ? `${c.title}` : `_${c.title}`;
            return t;
        }, {
            GoodsName: '',
            SkuID: '',
        }), [['p1', 'SkuID']]);
        if (!this.isCartWithPro) {
            return this.$Toast('订单包含不支持购物车结算的商品，请刷新购物车重新选择');
        }
        let order_id;
        if (!this.receiver.id) {
            return this.$Toast('请选择收货地址');
        }
        if (this.remark === '请输入备注信息') {
            this.remark = '';
        }
        let data = {
            coupon_codes: [this.market.coupon.code].filter(el => el),
            receiver_info: {
                receive_id: this.receiver.id,
                receive_name: this.receiver.name,
                receive_phone: this.receiver.phone,
                receive_province: this.receiver.province_name,
                receive_city: this.receiver.city_name,
                receive_district: this.receiver.district_name,
                receive_address: this.receiver.address,
            },
            user_remark: this.remark,
            freight: this.cartInfo.freight,
            total_fee: this.payAmountCart,
            skus: this.cartInfo.product_info.sku_info.map(el => {
                console.log(this.isVip && el.vip_price !== null, el.sale_price);
                return {
                    sku_id: el.id,
                    num: el.num,
                    sku_price: this.isVip && el.vip_price !== null ? el.vip_price : el.sale_price,
                    type: el.item_type,
                    item_type: el.item_type,
                    gifts: el.gifts,
                };
            }),
            is_comparison_price: 1,
        };
        const { data: orderRes } = await goodsApi.createOrder(data);
        if (orderRes.fail_code) {
            let flag = await showDiv(ConfirmPop, {
                confirmInfo: {
                    content: '商品价格发生变化，是否选择继续支付？',
                    cancelName: '取消',
                    confirmName: '继续支付',
                },
            });
            if (flag) {
                const { data: orderRes } = await goodsApi.createOrder({
                    ...data,
                    is_comparison_price: 0,
                });
                order_id = orderRes.id;
            }
            else
                return;
        }
        else {
            order_id = orderRes.id;
        }
        // 电商埋点-提交订单成功
        await uploadEvent.sendRecord('ConfirmOrder_Submit_Success', '', { Tid: orderRes.tid }, [['p1', 'Tid']]);
        let _redirect = `${window.location.origin}/goods/payDone?tid=${orderRes.tid}&isCart=true`;
        if (+orderRes.fee < 0.01) {
            return window.location.replace(_redirect);
        }
        console.log('======', orderRes);
        if (order_id) {
            if (this.payType === 'alipay' || this.payType === 'alipay_hb') {
                let payType = orderRes.pay_type;
                if (!payType) {
                    payType = {
                        wechat: 1,
                        alipay: 2,
                        coin: 4,
                        alipay_hb: 17,
                        combined_payment: 1000,
                    }[this.payType];
                }
                this.$router.push({
                    path: 'orderPay',
                    query: {
                        order_id: orderRes.id,
                        pay_type: payType,
                        pay_channel: 3 + '',
                        _redirect,
                        hbfq_num: this.payFqInfo.stage || 0,
                    },
                });
            }
            else {
                let pay = await goodsApi.payOrder({
                    order_id: order_id,
                    pay_channel: 3,
                    pay_type: 1,
                });
                // wechat: 1,
                // alipay: 2,
                // coin: 4,
                // alipay_hb: 17,
                // combined_payment: 1000,
                let payInfo = pay.data.data;
                window.location.replace(`//${config.env === 'production'
                    ? window.location.host
                    : 'm.ivydad.com.cn'}/pay/?${qs.stringify({
                    pay: {
                        ...payInfo,
                    },
                    redirect: _redirect,
                })}`);
            }
        }
    }
    checkedCoin() {
        this.useCoin = !this.useCoin;
    }
    checkedWithdraw() {
        this.useWithdraw = !this.useWithdraw;
    }
    hideBindPhone() {
        this.showBindPhone = false;
    }
};
tslib_1.__decorate([
    Watch('receiver')
], OrderConFirm.prototype, "getFreight", null);
OrderConFirm = tslib_1.__decorate([
    Component({
        components: {
            Address,
            GoodsInfo,
            Pay,
            InvalidGoods,
            BindPhone,
        },
        filters: {
            address(receiver) {
                return `${receiver.province_name}${receiver.city_name}${receiver.district_name || ''}${receiver.address}`;
            },
            payTypeConverter(payType) {
                return PAY_TYPE[payType] || '微信支付'; // 待扩展
            },
            number2Fixed: num => {
                const number = +num;
                return number ? `${number.toFixed(2)}` : '0.00';
            },
        },
    })
], OrderConFirm);
export default OrderConFirm;
